module.exports = __webpack_public_path__ + "img/black-2.d6dcc7c6.png";